module.exports = __webpack_public_path__ + "static/header-d3bf1d570d9daa8c5cf99cc4dec9732a.mp4";